module.exports = __webpack_public_path__ + "9ec8f62d848ce937572f1b6091cd7f4c.svg";